import { jsx as _jsx } from "react/jsx-runtime";
import { MarkdownBoldIcon, MarkdownItalicIcon, MarkdownUnderlineIcon, MarkdownCodeIcon } from '@prophecy/icons';
import { BoldPlugin, ItalicPlugin, UnderlinePlugin } from '@udecode/plate-basic-marks/react';
import { CodeBlockPlugin } from '@udecode/plate-code-block/react';
import { useEditorRef, useMarkToolbarButton as useMarkToolbarButtonBase, useMarkToolbarButtonState } from '@udecode/plate/react';
import { StyledButton } from './styled';
import { focusEditorAfterOperation, useToolbarButtonClick } from './utils';
const useMarkToolbarButton = (state) => {
    const { props, ...rest } = useMarkToolbarButtonBase(state);
    const editor = useEditorRef();
    const onClick = () => {
        editor.tf.toggleMark(state.nodeType, { remove: state.clear });
    };
    return { props: { ...props, onClick }, ...rest };
};
export function BoldButton() {
    const state = useMarkToolbarButtonState({ nodeType: BoldPlugin.key });
    const { props } = useMarkToolbarButton(state);
    const onClick = useToolbarButtonClick(props.onClick);
    return (_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', "data-active": state.pressed, ...props, onClick: onClick, icon: _jsx(MarkdownBoldIcon, { type: 'extended' }), tooltip: 'Bold (\u2318+B)', "aria-label": 'Bold', "data-test-id": 'markdown-editor-bold-button' }));
}
export function ItalicButton() {
    const state = useMarkToolbarButtonState({ nodeType: ItalicPlugin.key });
    const { props } = useMarkToolbarButton(state);
    const onClick = useToolbarButtonClick(props.onClick);
    return (_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', "data-active": state.pressed, ...props, onClick: onClick, icon: _jsx(MarkdownItalicIcon, { type: 'extended' }), tooltip: 'Italic (\u2318+I)', "aria-label": 'Italic', "data-test-id": 'markdown-editor-italic-button' }));
}
export function UnderlineButton() {
    const state = useMarkToolbarButtonState({ nodeType: UnderlinePlugin.key });
    const { props } = useMarkToolbarButton(state);
    const onClick = useToolbarButtonClick(props.onClick);
    return (_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', "data-active": state.pressed, ...props, onClick: onClick, icon: _jsx(MarkdownUnderlineIcon, { type: 'extended' }), tooltip: 'Underline (\u2318+U)', "aria-label": 'Underline', "data-test-id": 'markdown-editor-underline-button' }));
}
export function CodeBlockButton() {
    const editor = useEditorRef();
    const onClick = () => {
        focusEditorAfterOperation(editor, () => {
            editor.tf.toggleBlock(CodeBlockPlugin.key);
        });
    };
    const _onClick = useToolbarButtonClick(onClick);
    return (_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', onClick: _onClick, icon: _jsx(MarkdownCodeIcon, { type: 'extended' }), tooltip: 'Code Block', "aria-label": 'Code Block', "data-test-id": 'markdown-editor-code-block-button' }));
}
